import React from 'react';
import cl from './MyBanner.module.css'
import {useNavigate} from "react-router-dom";

const MyBanner = ({background, title, desc, isBlue, image, entity}) => {
    const navigate = useNavigate()
    return (
        <div className={cl.banner} style={{background: background}}>
            <div className={cl.bannerBody}>
                <div className={cl.text}>
                    <p className={`${cl.title} ${isBlue ? cl.titleG : cl.titleW}`}>
                        {title}
                    </p>
                    <p className={`${cl.desc} ${isBlue ? cl.descG : cl.descw}`}>
                        {desc}
                    </p>
                </div>
                <button
                    className={`${cl.bannerBtn} ${isBlue ? cl.blue : cl.white}`}
                    onClick={() => navigate(`/${entity}/add`)}
                >
                    Add new {entity}
                </button>
            </div>
            <img src={image} alt={"student"}/>
        </div>
    );
};

export default MyBanner;